// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  min-height: 25px;
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  /* stylelint-disable-next-line*/
  afterpay-placement {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      --logo-badge-width: 74px;
    }
  }

  .afterPayMessagingWrapper {
    display: flex;
    justify-content: ${(props) => (props.centered ? 'center' : 'flex-start')};
    align-items: center;
    flex-wrap: wrap;
    min-height: 37px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
    ${(props) => (props.centered ? 'justify-content: center;' : '')}
  }

  .messaging-text {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    }
  }
  .boldmessaging-text {
    font-weight: 800;
  }

  .afterPayModalWrapper {
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.theme.colors.AFTERPAY.MINT};
    padding-top: 50px;
  }

  .imageWrapper {
    position: absolute;
    right: 0;
    z-index: 1;
    align-items: flex-end;
    justify-content: center;
    margin-top: 40px;
  }

  .styledText {
    line-height: 16px;
  }

  .styledInfoIcon {
    margin-left: 3px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-left: 2px;
    }
    cursor: pointer;
  }

  .afterPayImage {
    width: 84px;
    display: inline-block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 64px;
    }
    img {
      vertical-align: middle;
    }
  }

  &.pdp-redesign-afterpay-message {
    min-height: unset;

    .afterPayMessagingWrapper {
      min-height: unset;
      font-size: 12px;
    }

    .afterPayImage {
      vertical-align: top;
    }

    .afterPayImage,
    .afterPayImage img {
      height: 12px;
      width: 64px;
    }

    .messaging-text {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      display: inline;
      vertical-align: middle;
    }
    .boldmessaging-text {
      color: #1a1a1a;
      font-family: Nunito;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;
    }

    .info-icon-wrapper {
      display: inline-flex;
      align-items: flex-end;
      vertical-align: middle;
      width: 12px;
      height: 12px;
      margin-left: 2px;
    }

    .styledInfoIcon {
      margin: 0;
      display: inline-block;
      cursor: pointer;
      width: 12px;
      height: 12px;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      .afterPayMessagingWrapper,
      .messaging-text,
      .boldmessaging-text {
        font-size: 14px;
        line-height: 14px;
      }
    }
  }
  &.cashapp-afterpay-rebranding-wrapper {
    min-height: 16px;
    .afterPayImage {
      display: inline-block;
      vertical-align: top;
      height: 16px;
      width: 64px;
    }
    .boldmessaging-text {
      font-weight: 800;
    }

    .messaging-text-wrapper,
    .messaging-text {
      font-size: 12px;
    }
    .afterPayImage img {
      height: 16px;
      vertical-align: unset;
    }
    .messaging-text {
      letter-spacing: 0.2px;
      font-weight: 500;
      vertical-align: unset;
      margin: 0 3px;
    }
    .styledInfoIcon {
      width: 13px;
      height: 13px;
      margin-top: 2px;
    }
    .info-icon-wrapper {
      display: inline;
      vertical-align: middle;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      .afterPayMessagingWrapper,
      .messaging-text,
      .boldmessaging-text {
        font-size: 12px;
        line-height: 12px;
      }
      .messaging-text {
        margin: 0;
      }
      .afterPayMessagingWrapper {
        min-height: 16px;
        margin-top: 0;
      }
    }
  }
`;

export default styles;
